import Modal from 'components/ui/Modal/Modal'
import UserItemImage from './UserItemImage'
import UserItemEmail from './UserItemEmail'
import UserItemBadgeRole from './UserItemBadgeRole'
import { CustomButton } from 'components/ui'
import { useParams } from 'react-router-dom'
import { useChangeUserRole } from 'lib/react-query/queriesProject'

const ModalEditUserRole = ({ user, rol, onClose }) => {
  const params = useParams()
  const proyectoId = params.idProject
  const mutation = useChangeUserRole()

  const esAdmin = rol === 'Administrador'
  const nuevoRol = esAdmin ? 'Usuario' : 'Administrador'

  const handleChangeRol = () => {
    const direccion = esAdmin ? 'a-users' : 'a-user'

    mutation.mutate(
      {
        proyectoId,
        usuarioId: user.user_id,
        direccion,
      },
      {
        onSuccess: () => {
          onClose()
        },
      }
    )
  }

  return (
    <Modal onClose={onClose}>
      <div className="edit-user-data-modal-grid">
        <h1>Cambiar rol</h1>
        <div className="edit-user-data-modal-container">
          <UserItemImage user={user} />
          <UserItemEmail user={user} />
          <UserItemBadgeRole rol={rol} />
        </div>
        <div className="edit-user-buttons-modal">
          <CustomButton className="btn-l" type="light" onClick={onClose}>
            Cancelar
          </CustomButton>
          <CustomButton className="btn-l" onClick={handleChangeRol}>
            Hacer {nuevoRol}
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default ModalEditUserRole
